import type { InjectionKey } from 'vue';

type RequirementStepInjection = {
  isLastRequirement: ComputedRef<boolean>
};

export const REQUIREMENT_UI_KEY = Symbol('requirementUIInjectKey') as InjectionKey<RequirementStepInjection>;

export function useRequirementUI() {
  const injectedValue = inject(REQUIREMENT_UI_KEY);

  if (!injectedValue) throw new Error(`No value found with key ${String(REQUIREMENT_UI_KEY)}`);

  return {
    ...injectedValue,
  };
}
